import { useEffect, useState, useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDownloadAnalytics } from 'services/download-analytics'
import { setShowPaymentModal } from 'actions'
import { addUpgradeReason, hasFeature } from 'utils/general'
import { F_DOWNLOAD_ANALYTICS } from '../../../../constants/plans/constants'

export const useAnalyticsDownloads = ({ domain, period = '30d', startDate, endDate }) => {
  const dispatch = useDispatch()
  const productId = useSelector((state) => state.manage.userProfile.productId) || null

  const [downloadStats, setDownloadStats] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  const hasAccess = useMemo(() => {
    return hasFeature(productId, F_DOWNLOAD_ANALYTICS)
  }, [productId])

  const fetchDownloadAnalytics = useCallback(async () => {
    if (!hasAccess) {
      setIsLoading(false)
      return
    }

    setIsLoading(true)
    setError(null)

    try {
      const domainValue = typeof domain === 'object' ? domain.subdomain : domain
      const params = { domain: domainValue, period }

      if (period === 'custom' && startDate && endDate) {
        params.startDate = startDate
        params.endDate = endDate
      }

      const { data } = await getDownloadAnalytics(params)
      setDownloadStats(data || [])
    } catch (err) {
      console.error('Error fetching download analytics:', err)
      setError('Failed to load download analytics')
      setDownloadStats([])
    } finally {
      setIsLoading(false)
    }
  }, [domain, period, startDate, endDate, hasAccess])

  useEffect(() => {
    fetchDownloadAnalytics()
  }, [fetchDownloadAnalytics])

  const handleUpgrade = () => {
    addUpgradeReason('View Download Analytics')
    dispatch(setShowPaymentModal(true))
  }

  const hasDownloads = downloadStats.length > 0

  return {
    downloadStats,
    isLoading,
    error,
    hasAccess,
    hasDownloads,
    handleUpgrade,
    refetch: fetchDownloadAnalytics
  }
}
